import { render, staticRenderFns } from "./LoadOrderDetails.vue?vue&type=template&id=3fca376b"
import script from "./LoadOrderDetails.vue?vue&type=script&lang=js"
export * from "./LoadOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports